import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-packet-analyzer',
  templateUrl: './packet-analyzer.component.html',
  styleUrls: ['./packet-analyzer.component.css']
})
export class PacketAnalyzerComponent implements OnInit {

  flutterAppUrl = "assets/pa/index.html";

  constructor() { }

  ngOnInit(): void {
  }

}
